var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":_vm.clearCache}},[_vm._v("Clear Cache")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }